import React, { Component } from "react";
import { Card, Button, Icon } from "semantic-ui-react";
import { BaseURL } from "../../api/Service";

class TenderSmall extends Component {
  showFile(blob) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], { type: "application/pdf" });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    var link = document.createElement("a");
    link.href = data;
    link.download = `${this.props.title}.pdf`;
    link.click();
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data), 100;
    });
  }

  handleClick(id, index) {
    fetch(`${BaseURL}api/tender/attachment/${id}/${index}`, {
      method: "GET",
    })
      .then((r) => r.blob())
      .then(this.showFile.bind(this));
  }
  render() {
    let up = this.props.uploadInfo;
    let item = [];
    up.forEach((el, index) => {
      item.push(
        <Button
          key={index}
          onClick={this.handleClick.bind(this, this.props.id, index)}
          icon
          labelPosition="left"
        >
          <Icon name="download" />
          File{index + 1}
        </Button>
      );
    });
    return (
      <Card>
        <Card.Content>
          <div className="notice-list-item">
            <h3>{this.props.title}</h3>
            <h6 style={{ color: "green" }}>{this.props.description[0].type}</h6>
            <h6>
              Announcement date: {this.props.date} | Opening Date:{" "}
              {this.props.description[0].date_opening} | Closing Date:{" "}
              {this.props.description[0].date_closing}
            </h6>
            <p>{this.props.description[0].description}</p>
            <p dangerouslySetInnerHTML={{ __html: this.props.message }}></p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, 100px)",
                gridColumnGap: "15px",
                gridRowGap: "10px",
              }}
            >
              {item}
            </div>
          </div>
        </Card.Content>

        <Card.Content extra>
          <div>
            <Button primary type="button" onClick={this.props.editClick}>
              Edit
            </Button>{" "}
            &nbsp;
            <Button
              color="red"
              type="button"
              onClick={this.props.onDeleteClick}
            >
              Delete
            </Button>
          </div>
        </Card.Content>
      </Card>
    );
  }
}
export default TenderSmall;



// WEBPACK FOOTER //
// ./src/HomeComponents/Tender/TenderSmall.js